import { getLabUploadSummary, LabUploadSummary } from 'api/labs';
import { QueryOptions, useQueryWithErrorAndRetrySnackbar } from 'utils/useQueryWithErrorAndRetrySnackbar';

export const getLabUploadSummaryQueryKey = (labId: string) => ['labUploadSummary', labId];

export const useLabUploadSummary = (labId: string, queryOptions: QueryOptions<LabUploadSummary> = {}) =>
  useQueryWithErrorAndRetrySnackbar(
    getLabUploadSummaryQueryKey(labId),
    ({ signal }) => getLabUploadSummary(labId, signal),
    {
      enabled: Boolean(labId),
      queriedEntityName: 'lab upload summary',
      ...queryOptions,
    }
  );
